import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, ease: "easeOut", delay }}
  >
    {children}
  </motion.div>
);
